import React, { useState } from 'react'
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import LongFormDialog from '../../../../../components/Dialog/LongFormDialog';
import EnterSurveyForm from '../../../../LeadCompliance/components/Header/EnterSurveyForm';

function UploadSurveyForm({ params, refetchUnits }) {
  const [anchorEl, setAnchorEl] = useState(false);

  const handleClose = () => {
    setAnchorEl(false);
    refetchUnits?.();
  };
  return (
    <>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Survey Response"}
          btnTitle={"Confirm"}
        >
          <EnterSurveyForm
            onClose={handleClose}
            initialData={{
              dates: new Date(),
              survey_id: params.row.compliance?.survey_id,
            }}
          />
        </LongFormDialog>
      )}
      <CloudUploadIcon
        fontSize="medium"
        className="cursor-pointer"
        color="action"
        onClick={() => setAnchorEl(true)}
      />
    </>
  );
}

export default UploadSurveyForm